import { useParams, useNavigate } from "react-router-dom";
import { ROUTES } from "../../../routes/AppRouterConfig";
import downloadIcon from "../../../images/icons/download_dark.svg";
import zipIcon from "../../../images/icons/zip_icon.svg";

const Drawings = () => {
  const { sectionId } = useParams();
  const navigate = useNavigate();

  // Маппинг sectionId на полные названия секций
  const sectionIdToNameMap = {
    GPD: "GPD – Циркуляционные насосы с «мокрым» ротором",
    DHT: "DHT – Дренажные насосы для высокотемпературных стоков",
    EPP: "EPP – Вертикальные одноступенчатые насосы ин-лайн",
  };

  // Маппинг полных названий на sectionId
  const nameToSectionIdMap = {
    "GPD – Циркуляционные насосы с «мокрым» ротором": "GPD",
    "DHT – Дренажные насосы для высокотемпературных стоков": "DHT",
    "EPP – Вертикальные одноступенчатые насосы ин-лайн": "EPP",
  };

  const pumpSections = [
    "GPD – Циркуляционные насосы с «мокрым» ротором",
    "DHT – Дренажные насосы для высокотемпературных стоков",
    "EPP – Вертикальные одноступенчатые насосы ин-лайн",
  ];

  // Определяем текущую секцию на основе URL параметра
  const getCurrentSection = () => {
    if (sectionId && sectionIdToNameMap[sectionId]) {
      return sectionIdToNameMap[sectionId];
    }
    return null;
  };

  const currentSection = getCurrentSection();

  const gpdDrawings = [
    {
      name: "Aquastrong GPD (DWG 3D)",
      path: "/docs/drawings/Aquastrong GPD (DWG 3D).7z",
    },
  ];

  const dhtDrawings = [
    {
      name: "DHT (DWG 3D)",
      path: "/docs/drawings/DHT (DWG 3D).7z",
    },
    {
      name: "DHT (STP 3D)",
      path: "/docs/drawings/DHT (STP 3D).7z",
    },
  ];

  const eppDrawings = [
    {
      name: "EPP32 (DWG 3D)",
      path: "/docs/drawings/EPP32 (DWG 3D).7z",
    },
    {
      name: "EPP40 (DWG 3D)",
      path: "/docs/drawings/EPP40 (DWG 3D).7z",
    },
    {
      name: "EPP50 (DWG 3D)",
      path: "/docs/drawings/EPP50 (DWG 3D).7z",
    },
    {
      name: "EPP65 (DWG 3D)",
      path: "/docs/drawings/EPP65 (DWG 3D).7z",
    },
    {
      name: "EPP80 (DWG 3D)",
      path: "/docs/drawings/EPP80 (DWG 3D).7z",
    },
    {
      name: "EPP100 (DWG 3D)",
      path: "/docs/drawings/EPP100 (DWG 3D).7z",
    },
    {
      name: "EPP125 (DWG 3D)",
      path: "/docs/drawings/EPP125 (DWG 3D).7z",
    },
    {
      name: "EPP150 (DWG 3D)",
      path: "/docs/drawings/EPP150 (DWG 3D).7z",
    },
    {
      name: "EPP200 (DWG 3D)",
      path: "/docs/drawings/EPP200 (DWG 3D).7z",
    },
    {
      name: "EPP250 (DWG 3D)",
      path: "/docs/drawings/EPP250 (DWG 3D).7z",
    },
    {
      name: "EPP300 (DWG 3D)",
      path: "/docs/drawings/EPP300 (DWG 3D).7z",
    },
  ];

  const openSection = (section) => {
    const sectionId = nameToSectionIdMap[section];
    if (sectionId) {
      navigate(`/documents/drawings/${sectionId}`);
    }
  };

  const goBack = () => {
    navigate(ROUTES.DocumentationDrawings.path);
  };

  const openFile = (path) => {
    if (!path) return;

    const link = document.createElement("a");
    link.href = path;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const renderSectionContent = (section) => {
    if (section === "GPD – Циркуляционные насосы с «мокрым» ротором") {
      return (
        <div className="cards w-100">
          {gpdDrawings.map((item) => (
            <div
              className="card-item flex-column column-start flex-between border-radius-base"
              key={item.path || item.name}
            >
              <span className="title text-m">{item.name}</span>
              <div className="flex-row gap-4x">
                <button
                  type="button"
                  onClick={() => openFile(item.path)}
                  className="download btn-outlined size-m flex-row"
                >
                  Скачать
                  <img alt="download" src={downloadIcon} />
                </button>
                <img src={zipIcon} alt="document"></img>
              </div>
            </div>
          ))}
        </div>
      );
    }
    if (section === "DHT – Дренажные насосы для высокотемпературных стоков") {
      return (
        <div className="cards w-100">
          {dhtDrawings.map((item) => (
            <div
              className="card-item flex-column column-start flex-between border-radius-base"
              key={item.path || item.name}
            >
              <span className="title text-m">{item.name}</span>
              <div className="flex-row gap-4x">
                <button
                  type="button"
                  onClick={() => openFile(item.path)}
                  className="download btn-outlined size-m flex-row"
                >
                  Скачать
                  <img alt="download" src={downloadIcon} />
                </button>
                <img src={zipIcon} alt="document"></img>
              </div>
            </div>
          ))}
        </div>
      );
    }
    if (section === "EPP – Вертикальные одноступенчатые насосы ин-лайн") {
      return (
        <div className="cards w-100">
          {eppDrawings.map((item) => (
            <div
              className="card-item flex-column column-start flex-between border-radius-base"
              key={item.path || item.name}
            >
              <span className="title text-m">{item.name}</span>
              <div className="flex-row gap-4x">
                <button
                  type="button"
                  onClick={() => openFile(item.path)}
                  className="download btn-outlined size-m flex-row"
                >
                  Скачать
                  <img alt="download" src={downloadIcon} />
                </button>
                <img src={zipIcon} alt="document"></img>
              </div>
            </div>
          ))}
        </div>
      );
    }
    return null;
  };

  const renderSectionsList = () => {
    return (
      <div className="cards w-100">
        {pumpSections.map((section) => (
          <div
            key={section}
            className="card-item flex-column column-start flex-between border-radius-base"
          >
            <span className="title text-m">{section}</span>
            <div className="flex-row gap-4x">
              <button
                type="button"
                onClick={() => openSection(section)}
                className="download btn-outlined size-m flex-row"
              >
                Просмотреть
              </button>
            </div>
          </div>
        ))}
      </div>
    );
  };

  const renderCurrentSection = () => {
    return (
      <div className="section-view">
        <div className="section-header">
          <h2 className="section-name">{currentSection}</h2>
          <button
            type="button"
            onClick={goBack}
            className="back-button btn-outlined size-m"
          >
            Назад
          </button>
        </div>
        <div className="section-content">
          {renderSectionContent(currentSection)}
        </div>
      </div>
    );
  };

  return (
    <div className="flex-column gap-grid column-start w-100">
      {currentSection ? renderCurrentSection() : renderSectionsList()}
    </div>
  );
};

export default Drawings;
